/**
 * 页面上的品牌标识(名字、方块里的字或图形、口号、名字下面那行小字)该出谁的 —— 和标签页上的站点图标
 * (ui/site-icon.ts)是同一条规矩:
 * - 站点信息还没取到:不知道这是不是机构站点、开没开白标,宁可空着也不出平台的
 *   (正常情况下碰不到:第一次进页面前会先等站点信息,见 router 的守卫;接口一直不回、等超时了才会空着出页面);
 * - 机构站点:机构在这一面上的显示名,方块里是名字的第一个字(它上传了 Logo 的话外壳会用 Logo 盖住);
 *   不带平台名下面那行小字;开了白标也不带平台口号;
 * - 站点信息取失败了,但站点码(子域名 / 手动选的站点)表明这是机构站点:还是不知道它叫什么、开没开白标 —— 照样空着;
 * - 平台站点(包括平台站点自己取站点信息失败):平台的名字、Logo 图形、口号和小字。
 */
export interface BrandIdentity {
  name: string;
  /** 品牌方块里的那个字 */
  mark: string;
  /** 方块里画平台 Logo 的图形(components/BrandGlyph.vue)而不是字 */
  glyph: boolean;
  slogan: string;
  /** 导航上品牌名下面那行小字(平台站点才有) */
  tagline: string;
}

export function brandIdentityFor(input: {
  /** 站点信息有没有结果了(stores/tenant.ts 的 settled) */
  settled: boolean;
  /** 机构在当前这一面上的显示名;平台站点 / 没取到是 null */
  orgName: string | null;
  /** 机构开了站点白标 */
  whiteLabel: boolean;
  /** 站点码表明这是机构站点(不是平台站点),不管站点信息取没取到 */
  orgSite: boolean;
  platform: { name: string; mark: string; slogan: string; tagline: string };
}): BrandIdentity {
  const blank = { name: '', mark: '', glyph: false, slogan: '', tagline: '' };
  if (!input.settled) return blank;
  if (input.orgName !== null)
    return {
      name: input.orgName,
      mark: input.orgName.slice(0, 1),
      glyph: false,
      slogan: input.whiteLabel ? '' : input.platform.slogan,
      tagline: '',
    };
  if (input.orgSite) return blank;
  return {
    name: input.platform.name,
    mark: input.platform.mark,
    glyph: true,
    slogan: input.platform.slogan,
    tagline: input.platform.tagline,
  };
}

/**
 * 第一次进页面前最多等站点信息多久(毫秒)。平时一两百毫秒就回来了;等的时候页面上是一个不带品牌的小转圈(App.vue)。
 * 接口一直不回(网络断断续续)才会等满:到点就先出页面,品牌位空着,之后信息到了页面自己更新。
 */
export const TENANT_WAIT_MS = 6000;
